/**
 * Created by iamso on 29.05.19.
 */

const WINDOW_ANIMATIONS = { 
    default: {
        open: function (callback) {
            const baseScale = this.window.scale;
            this.window.setScale(0.8 * baseScale);
            this.window.runAction(new cc.Sequence(
                new cc.ScaleTo(0.3, baseScale).easing(cc.easeBackOut())
            )).setFinalize(callback);
        },

        close: function (callback) {
            const baseScale = this.window.scale;
            this.window.runAction(new cc.Sequence(
                new cc.ScaleTo(0.2, 0.8 * baseScale).easing(cc.easeBackIn())
            )).setFinalize(callback);
        }
    },

    defaultTropic: {
        open: function (callback) {
            const baseScale = this.window.scale;
            this.window.setScale(0.9 * baseScale);
            this.window.runAction(new cc.Sequence(
                new cc.ScaleTo(0.2, baseScale).easing(cc.easeBackOut())
            )).setFinalize(callback);
        },

        close: function (callback) {
            const baseScale = this.window.scale;
            this.window.runAction(new cc.Sequence(
                new cc.ScaleTo(0.1, 0.5 * baseScale)
            )).setFinalize(callback);
        }
    },

    defaultHeroes: {
        open: function (callback) {
            const baseScale = this.window.scale;
            this.window.runAction(new cc.Sequence(
                new cc.ScaleTo(0.05, 0.99 * baseScale),
                new cc.ScaleTo(0.1, 1.01 * baseScale),
                new cc.ScaleTo(0.05, baseScale)
            )).setFinalize(callback);
        },

        close: function (callback) {
            const baseScale = this.window.scale;
            this.window.runAction(new cc.Sequence(
                new cc.ScaleTo(0.07, 1.02 * baseScale),
                new cc.ScaleTo(0.07, 0.7 * baseScale)
            )).setFinalize(callback);
        }
    },

    defaultRiddles: {
        open: function (callback) {
            const baseScale = this.window.scale;
            this.window.setVisible(false);

            const height = this.window.height;

            this.window.runAction(new cc.Spawn(
                new cc.Sequence(
                    new cc.MoveBy(0, 0, height * 0.05),
                    new cc.Show(),
                    new cc.MoveBy(0.07, 0, -height * 0.04),
                    new cc.MoveBy(0.1, 0, -height * 0.015),
                    new cc.MoveBy(0.08, 0, height * 0.01),
                    new cc.MoveBy(0.1, 0, -height * 0.005)
                ),
                new cc.Sequence(
                    new cc.ScaleTo(0, 0.98 * baseScale, 1.02 * baseScale),
                    new cc.DelayTime(0.07),
                    new cc.ScaleTo(0.1, 1.01 * baseScale, 0.99 * baseScale),
                    new cc.ScaleTo(0.08, 0.99 * baseScale, 1.01 * baseScale),
                    new cc.ScaleTo(0.1, baseScale)
                )
            )).setFinalize(callback);
        },

        close: function (callback) {
            const baseScale = this.window.scale;
            const height = this.window.height;

            this.window.runAction(new cc.Spawn(
                new cc.Sequence(
                    new cc.MoveBy(0.1, 0, -height * 0.01),
                    new cc.MoveBy(0.15, 0, height * 0.04)
                ),
                new cc.Sequence(
                    new cc.ScaleTo(0.1, 1.02 * baseScale, 0.98 * baseScale),
                    new cc.ScaleTo(0.15, 0.97 * baseScale, 1.03 * baseScale)
                )
            )).setFinalize(callback);
        }
    },

    slideUp: {
        open: function (callback) {
            this.window.setVisible(false);
            this.window.runAction(new cc.Sequence(
                new cc.MoveBy(0, 0, -this.window.height * 0.05),
                new cc.Show(),
                new cc.MoveBy(0.5, 0, this.window.height * 0.05).easing(cc.easeBackOut())
            )).setFinalize(callback);
        },

        close: function (callback) {
            callback && callback();
        }
    },

    fromBelow: {
        open: function (callback) {
            this.window.setVisible(false);
            this.window.runAction(new cc.Sequence(
                new cc.MoveBy(0, 0, -this.window.height),
                new cc.Show(),
                new cc.MoveBy(0.3, 0, this.window.height).easing(cc.easeBackOut())
            )).setFinalize(() => {
                this.window.setVisible(true);
                callback();
            });
        },

        close: function (callback) {
            this.window.runAction(new cc.Sequence(
                new cc.MoveBy(0.4, 0, -this.window.height).easing(cc.easeBackIn()),
                new cc.Hide()
            )).setFinalize(callback);
        }
    },

    instant: {
        open: function (callback) {
            callback();
        },

        close: function (callback) {
            callback && callback();
        }
    }
};